import type { QuoterTranslations } from "../interfaces/quoter";

export const quoterTranslations: QuoterTranslations = {
  header_title: "Shipping quoter",
  header_subtitle: "Calculate your international transfers instantly.",
  header_history_button: "History",
  step1_title: "Step 1: What do you want to do?",
  step1_send_title: "I want to send",
  step1_send_description: "Send money to another currency",
  step1_receive_title: "I want to receive",
  step1_receive_description: "Calculate how much I need to pay",
  step1_rate_label: "Current exchange rate",
  step1_equiv_to: "equals",
  step1_quote_to_see_rate: "Get a quote to see the rate",
  step2_title: "Step 2: Transfer details",
  step2_origin_label: "Origin currency",
  step2_destination_label: "Destination currency",
  step2_select_currency: "Select currency",
  step2_amount_send: "Amount to send",
  step2_amount_receive: "Amount to receive",
  step2_amount_placeholder: "E.g.: 1,000,000",
  step2_commission_label: "Commission (%)",
  form_error_select_currencies: "Select origin and destination currency.",
  form_error_valid_amount: "Enter a valid amount.",
  form_error_country_not_found: "Country not found for the selected currency.",
  form_error_quote: "Error getting the quote.",
  form_button_quoting: "Getting quote…",
  form_button_submit: "Get quote now",
  summary_total_pay: "Total to pay",
  summary_commission_suffix: "commission ({{percent}}%)",
  summary_amount_converted: "Converted amount",
  summary_beneficiary_receives: "Total beneficiary receives",
  result_title: "Quotation result",
  result_amount_sent: "Amount sent",
  result_amount_received: "Amount to receive",
  result_amount_converted: "Converted amount",
  result_commission: "Commission ({{percent}}%)",
  result_effective_rate_title: "Coloca Rate",
  footer_secure: "Secure",
  footer_instant: "Instant",
  footer_copyright: "© 2024 Logística Global S.A. All rights reserved.",
  history_title: "Quotation history",
  history_refresh: "Refresh",
  history_back: "Back",
  history_no_permission: "You do not have permission to view the quotation history.",
  history_filters_title: "Filters",
  history_filters_origin: "Origin currency",
  history_filters_destination: "Destination currency",
  history_filters_all: "All",
  history_filters_start_date: "Start date",
  history_filters_end_date: "End date",
  history_filters_apply: "Apply filters",
  history_filters_clear: "Clear filters",
  history_table_showing_one: "Showing 1 quotation on this page (Total: {{total}})",
  history_table_showing_many: "Showing {{count}} quotations on this page (Total: {{total}})",
  history_table_show_label: "Show:",
  history_table_empty: "No quotations to display.",
  history_table_th_origin: "Origin",
  history_table_th_destination: "Destination",
  history_table_th_send: "Send",
  history_table_th_receive: "Receive",
  history_table_th_commission: "Commission %",
  history_table_th_rate: "Rate",
  history_table_th_created_by: "Created by",
  history_table_th_date: "Date",
  history_table_th_actions: "Actions",
  history_table_view_aria: "View quotation",
  history_table_view: "View",
  history_modal_title: "Quotation details",
  history_modal_close_aria: "Close",
  history_modal_error_load: "Could not load quotation details.",
  history_modal_amount_receive: "Amount to receive",
  history_modal_origin: "Origin",
  history_modal_destination: "Destination",
  history_modal_commission: "Transfer commission ({{percent}}%)",
  history_modal_total_debit: "Total to debit",
  history_modal_created_by: "Created by:",
  history_modal_date: "Date:",
  history_modal_close_button: "Close",

  history_pagination_records: "Records {{from}} to {{to}} of {{total}}",
  history_pagination_total_pages: "Total pages ({{lastPage}})",
  history_pagination_first_page: "First page",
  history_pagination_prev_page: "Previous page",
  history_pagination_next_page: "Next page",
  history_pagination_last_page: "Last page",
};
